import { defineComponent, toRefs, ref, provide, readonly, onMounted, watch } from '@vue/composition-api';
import { contextKey } from './SdsTabsContext.js';

var script = defineComponent({
    name: 'SdsTabs',
    props: {
        selectedTab: {
            type: String,
            required: false,
            default: undefined,
        },
        background: {
            type: String,
            required: false,
            default: 'default',
        },
        alignment: {
            type: String,
            required: false,
            default: 'left',
        },
    },
    emits: [
        'update:selectedTab',
    ],
    model: {
        prop: 'selectedTab',
        event: 'update:selectedTab',
    },
    setup: function (props, _a) {
        var emit = _a.emit;
        var _b = toRefs(props), background = _b.background, alignment = _b.alignment;
        var currentTab = ref(props.selectedTab);
        var tabsRef = ref();
        function setValue(value) {
            currentTab.value = value;
            emit('update:selectedTab', value);
        }
        function setValueFromChild(value) {
            if (props.selectedTab == null) { // Uncontrolled, handle it internally
                setValue(value);
            }
            else { // Controlled, let the parent handle it
                emit('update:selectedTab', value);
            }
        }
        function navigateToSibling(element, offset) {
            var parent = element.parentElement;
            var children = Array.from(parent.children);
            var eligibleChildren = children.filter(function (child) { return child instanceof HTMLButtonElement && !child.disabled; });
            var index = eligibleChildren.indexOf(element);
            var nextIndex = resolveIndex(index + offset, eligibleChildren.length);
            var nextElement = eligibleChildren[nextIndex];
            nextElement.focus();
            nextElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        function resolveIndex(index, count) {
            if (index < 0) {
                return count - 1;
            }
            else if (index >= count) {
                return 0;
            }
            else {
                return index;
            }
        }
        function handleKeyboardNavigation(event) {
            if (event.key === 'ArrowRight') {
                navigateToSibling(event.target, 1);
            }
            else if (event.key === 'ArrowLeft') {
                navigateToSibling(event.target, -1);
            }
        }
        function setFirstEligibleTab() {
            var tabs = tabsRef.value.querySelectorAll('.e2e-tab-item');
            var eligibleTabs = Array.from(tabs).filter(function (tab) { return !tab.disabled; });
            if (eligibleTabs.length > 0) {
                var firstTab = eligibleTabs[0];
                setValue(firstTab.dataset['value']);
            }
        }
        provide(contextKey, {
            background: readonly(background),
            alignment: readonly(alignment),
            value: readonly(currentTab),
            setValue: setValueFromChild,
            handleKeyboardNavigation: handleKeyboardNavigation,
        });
        onMounted(function () {
            if (!currentTab.value) {
                setFirstEligibleTab();
            }
        });
        watch(function () { return props.selectedTab; }, function (newValue) {
            if (newValue !== currentTab.value) {
                setValue(newValue);
            }
        });
        return {
            tabsRef: tabsRef,
        };
    },
});

export default script;
